import { render, staticRenderFns } from "./RastrearPedido.vue?vue&type=template&id=76763065&scoped=true"
import script from "./RastrearPedido.vue?vue&type=script&lang=js"
export * from "./RastrearPedido.vue?vue&type=script&lang=js"
import style0 from "./RastrearPedido.vue?vue&type=style&index=0&id=76763065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76763065",
  null
  
)

export default component.exports